/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/CreditCardTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { ResultAccumulationConfiguration } from '../frame_accumulation/FrameAccumulationTypes';
import { GenericDocument } from '../generic_document/GenericDocument';
/** @hidden */
export const CreditCardScanningStatusValues = [
    'SUCCESS',
    'ERROR_NOTHING_FOUND',
    'INCOMPLETE',
];
/**
Contains the result of running the credit card scanner.
*/
export class CreditCardScanningResult {
    /** @param source {@displayType `DeepPartial<CreditCardScanningResult>`} */
    constructor(source = {}) {
        this._released = false;
        if (source.detectionStatus !== undefined) {
            this.detectionStatus = source.detectionStatus;
        }
        else {
            throw new Error('detectionStatus must be present in constructor argument');
        }
        if (source.scanningStatus !== undefined) {
            this.scanningStatus = source.scanningStatus;
        }
        else {
            throw new Error('scanningStatus must be present in constructor argument');
        }
        if (source.creditCard !== undefined) {
            this.creditCard = source.creditCard != null ? new GenericDocument(source.creditCard) : null;
        }
        else {
            throw new Error('creditCard must be present in constructor argument');
        }
        if (source.quad !== undefined) {
            this.quad = source.quad.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('quad must be present in constructor argument');
        }
        if (source.quadNormalized !== undefined) {
            this.quadNormalized = source.quadNormalized.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('quadNormalized must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            detectionStatus: this.detectionStatus,
            scanningStatus: this.scanningStatus,
            creditCard: this.creditCard != null ? await this.creditCard.serialize(config) : null,
            quad: this.quad.map((it) => {
                return it;
            }),
            quadNormalized: this.quadNormalized.map((it) => {
                return it;
            }),
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.creditCard != null) {
                this.creditCard.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.creditCard != null) {
            await this.creditCard.encodeImages();
        }
    }
}
/**
Configuration for the credit card scanner.
*/
export class CreditCardScannerConfiguration {
    /** @param source {@displayType `DeepPartial<CreditCardScannerConfiguration>`} */
    constructor(source = {}) {
        /**
          If true, the document detector will be used to find where the credit card is in the input image.
          If false, the scanner will assume that the credit card has been pre-cropped and takes the entirety of the input image.
          
          Default is true
          */
        this.useDocumentDetector = true;
        /**
          Whether the expiry date is required for a successful scan.
          
          Default is true
          */
        this.requireExpiryDate = true;
        /**
          Whether the cardholder name is required for a successful scan.
          
          Default is true
          */
        this.requireCardholderName = true;
        /**
          Configuration for how to accumulate results.
          */
        this.resultAccumulationConfig = new ResultAccumulationConfiguration({});
        /**
          If true, the credit card image will be returned in creditCard field of CreditCardScanningResult.
          
          Default is false
          */
        this.returnCreditCardImage = false;
        /**
          Scanners typically can produce better results from a single image if they are allowed to spend a longer time analyzing it.
          
          On the other hand, scanners can produce even better results if they can analyze multiple images of the same subject and cross-check and combine the results.
          The processing mode tells the scanner whether to optimize for single or multiple images of a subject.
          
          Default is AUTO
          */
        this.processingMode = 'AUTO';
        if (source.useDocumentDetector !== undefined) {
            this.useDocumentDetector = source.useDocumentDetector;
        }
        if (source.requireExpiryDate !== undefined) {
            this.requireExpiryDate = source.requireExpiryDate;
        }
        if (source.requireCardholderName !== undefined) {
            this.requireCardholderName = source.requireCardholderName;
        }
        if (source.resultAccumulationConfig !== undefined) {
            this.resultAccumulationConfig = new ResultAccumulationConfiguration(source.resultAccumulationConfig);
        }
        if (source.returnCreditCardImage !== undefined) {
            this.returnCreditCardImage = source.returnCreditCardImage;
        }
        if (source.processingMode !== undefined) {
            this.processingMode = source.processingMode;
        }
    }
}
//# sourceMappingURL=CreditCardTypes.js.map